export default __webpack_public_path__ + "static/media/gt2.64c0abe1.png";